// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2oS4n","range":"MonthRangeSwitch_range__3jZGk","disabled":"MonthRangeSwitch_disabled__OPNFo"};